import styled from 'styled-components';

export const TransferDetail = styled.div`
	background: #f8f8f8;
	border-radius: 12px;
	padding: 12px;
	width: 100%;
`;

export const TransferDetailContainer = styled.div`
	align-items: center;
	border-bottom: 1px solid #f2f2f2;
	display: flex;
	justify-content: space-between;
	padding: 8px 0;

	&:first-child {
		padding-top: 0;
	}

	&:last-child {
		border-bottom: none;
		padding: 8px 0 0;
	}
`;

export const TransferItem = styled.p`
	color: #636172;
	font-size: 16px;
	font-weight: 400;
	letter-spacing: -0.013px;
	line-height: normal;
`;

export const TransferData = styled.p`
	align-items: center;
	color: #140f33;
	display: flex;
	flex-direction: row;
	font-size: 16px;
	font-weight: 400;
	gap: 8px;
	letter-spacing: -0.013px;
	line-height: normal;
`;
interface ButtonProps {
	border?: boolean;
}

export const Button = styled.button<ButtonProps>`
	align-items: center;
	background-color: ${({ theme }) => theme.colors.principal.pure};
	border: 1px solid
		${({ theme, border }) => (border ? theme.colors.principal.orion : theme.colors.principal.ceres)};
	border-radius: 8px;
	cursor: pointer;
	display: flex;
	height: 42px;
	justify-content: center;
	width: 42px;

	&:hover {
		border: 1px solid
			${({ theme, border }) =>
				border ? theme.colors.principal.orion : theme.colors.principal.vanth};
	}
`;
